@if (job()) {
  <div class="full layout-col">
    <!-- Toolbar Overrides Title-->
    <ng-template elderToolbarColumn="left">
      <elder-header [header]="'jobs.detail' | translate" [subheader]="job()?.id"></elder-header>
    </ng-template>
    @if (!job) {
      <div class="layout-col p-sm">
        <p>{{ 'context.notFound' | translate }}</p>
      </div>
    }
    <mat-tab-group class="flex">
      <!-- Assignments -->
      <mat-tab label="{{ 'jobs.assignments' | translate }}">
        <div class="full layout-col p-sm">
          <elder-table class="full" float [data]="dataContext" [idField]="'id'" matSort>
            <!-- WorkItem nr -->
            <ng-container matColumnDef="work-item">
              <th mat-header-cell *matHeaderCellDef style="width: 5%" mat-sort-header="posNr">
                {{ 'jobs.work-item' | translate }}
              </th>
              <td mat-cell *matCellDef="let wi">{{ wi.posNr }}</td>
            </ng-container>
            <!-- WorkItem WorkOrderId column -->
            <ng-container matColumnDef="work-order-id">
              <th
                mat-header-cell
                *matHeaderCellDef
                style="width: 10%"
                mat-sort-header="workOrderId"
              >
                {{ 'work.order' | translate }}
              </th>
              <td mat-cell *matCellDef="let wi">{{ wi.workOrderId }}</td>
            </ng-container>
            <!-- Production Lines column -->
            <ng-container matColumnDef="production-lines">
              <th mat-header-cell *matHeaderCellDef style="width: 85%">
                {{ 'jobs.production-line' | translate }}
              </th>
              <td mat-cell *matCellDef="let wi">
                <app-job-detail-production-line-view
                  class="full p-sm"
                  [workItem]="wi"
                  [assignments]="job()?.optimizedAssignments?.assignments"
                  [wcMetas]="job()?.initialAssignments?.workCenterMetas"
                ></app-job-detail-production-line-view>
              </td>
            </ng-container>
          </elder-table>
        </div>
      </mat-tab>
      <!-- Production Lines Utilisation -->
      <mat-tab label="{{ 'jobs.production-lines' | translate }}">
        @if (job()?.optimizedAssignments) {
          <section class="full p-xxl">
            <div class="full layout-col gap-xs">
              <app-job-detail-utilisation
                class="full"
                [groupBy]="'productionLine'"
                [job]="job()"
                xAxisLabel="{{ 'jobs.utilisation' | translate }} [h]"
                yAxisLabel="{{ 'jobs.production-line' | translate }}"
              >
              </app-job-detail-utilisation>
            </div>
          </section>
        }
      </mat-tab>
      <!-- Work Centers Utilisation -->
      <mat-tab label="{{ 'jobs.work-centers' | translate }}">
        @if (job()?.optimizedAssignments) {
          <section class="full p-xxl">
            <div class="full layout-col gap-xs">
              <app-job-detail-utilisation
                class="full"
                [groupBy]="'workCenter'"
                [job]="job()"
                xAxisLabel="{{ 'jobs.utilisation' | translate }} [h]"
                yAxisLabel="{{ 'jobs.work-center' | translate }}"
              >
              </app-job-detail-utilisation>
            </div>
          </section>
        }
      </mat-tab>
      <!-- Metrics -->
      <mat-tab label="{{ 'metrics.metrics' | translate }}">
        @if (job) {
          <section class="full layout-col gap-sm">
            <div class="flex layout-row gap-xs">
              <!-- General Metrics -->
              <div class="layout-col p-lg">
                <h2>{{ 'common.general' | translate }}</h2>
                <mat-chip-listbox class="mat-mdc-chip-set-stacked">
                  <mat-chip-option>
                    {{ 'jobs.duration' | translate }}:
                    {{ job()?.metrics?.metrics?.duration | isoDuration }}
                  </mat-chip-option>
                  @if (job()?.metrics?.metrics?.initialObjectives; as initialObjectives) {
                    <mat-chip-option>
                      {{ 'jobs.initialObjective' | translate }}: {{ initialObjectives | json }}
                    </mat-chip-option>
                  }
                  @if (job()?.metrics?.metrics?.bestSolutionObjectives; as bestSolutionObjectives) {
                    <mat-chip-option>
                      {{ 'jobs.bestObjective' | translate }}: {{ bestSolutionObjectives | json }}
                    </mat-chip-option>
                  }
                </mat-chip-listbox>
              </div>
              <!-- EAResultMetric -->
              <div class="layout-col p-lg">
                <h2>EAResultMetric</h2>
                <mat-chip-listbox class="mat-mdc-chip-set-stacked">
                  <mat-chip-option>
                    {{ 'metrics.iteration-count' | translate }}
                    : {{ job()?.metrics?.metrics?.eaMetrics?.iterationCount }}
                  </mat-chip-option>
                  <mat-chip-option>
                    {{ 'metrics.iteration-min-duration' | translate }}
                    :
                    {{ job()?.metrics?.metrics?.eaMetrics?.iterationMinDuration | isoDuration }}
                  </mat-chip-option>
                  <mat-chip-option>
                    {{ 'metrics.iteration-avg-duration' | translate }}
                    :
                    {{ job()?.metrics?.metrics?.eaMetrics?.iterationAvgDuration | isoDuration }}
                  </mat-chip-option>
                  <mat-chip-option>
                    {{ 'metrics.iteration-max-duration' | translate }}
                    :
                    {{ job()?.metrics?.metrics?.eaMetrics?.iterationMaxDuration | isoDuration }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </div>
              <!-- EAHistoryData -->
              <div class="layout-col p-lg">
                <h2>EAHistoryData</h2>
                <mat-chip-listbox class="mat-mdc-chip-set-stacked">
                  <p>{{ 'metrics.objectives' | translate }}:</p>
                  @for (objective of job()?.metrics?.metrics?.eaMetrics?.history?.objectiveLabels;
                    track objective) {
                    <mat-chip-option>
                      {{ objective }}
                    </mat-chip-option>
                  }
                </mat-chip-listbox>
                <mat-chip-listbox class="mat-mdc-chip-set-stacked">
                  <p>{{ 'algorithm.generations' | translate }}:</p>
                  <mat-chip-option>
                    {{ 'algorithm.generations-count' | translate }}
                    : {{ job()?.metrics?.metrics?.eaMetrics?.history?.generations?.length }}
                  </mat-chip-option>
                </mat-chip-listbox>
              </div>
              <!-- Environment Variables -->
              <div class="layout-col p-lg">
                <h2>{{ 'metrics.environment-variables' | translate }}</h2>
                <mat-chip-listbox class="mat-chip-list-stacked">
                  @for (entry of job()?.metrics?.environment | keyvalue; track entry) {
                    <mat-chip-option> '{{ entry.key }}' : {{ entry.value }}</mat-chip-option>
                  }
                </mat-chip-listbox>
              </div>
            </div>
            <div class="flex layout-col">
              <elder-exception-detail [error]="job()?.error"></elder-exception-detail>
            </div>
          </section>
        }
      </mat-tab>
      <!-- Optimisation Objectives (Convergence) -->
      <mat-tab label="{{ 'metrics.objectives' | translate }}">
        @if (job()?.metrics) {
          <section class="full layout-col p-xxl">
            <app-job-detail-convergence
              class="full flex"
              [historyData]="job()?.metrics?.metrics?.eaMetrics?.history"
              xAxisLabel="{{ 'algorithm.generation' | translate }}"
              yAxisLabel="{{ 'metrics.objective-value' | translate }}"
            >
            </app-job-detail-convergence>
          </section>
        }
      </mat-tab>
      <!-- Work Centers enforced assignment Utilisation -->
      <mat-tab label="{{ 'jobs.enforced-assignments' | translate }}">
        @if (job()?.optimizedAssignments) {
          <section class="full p-xxl">
            <div class="full layout-col gap-xs">
              <app-job-detail-utilisation
                class="full"
                [groupBy]="'workCenter'"
                [filterFn]="enforcedAssignmentFilterFn"
                [job]="job()"
                xAxisLabel="{{ 'jobs.utilisation' | translate }} [h]"
                yAxisLabel="{{ 'jobs.work-center' | translate }}"
              >
              </app-job-detail-utilisation>
            </div>
          </section>
        }
      </mat-tab>
    </mat-tab-group>
  </div>
}
